import { IWaybill, IWaybillPersistence } from '../interfaces';

const round2 = (value: number) => Math.round(value * 100) / 100;

export class WaybillMapper {
  public static toDomain(w: IWaybillPersistence): IWaybill {
    return {
      id: w.declaration_id,
      trackCode: w.track_code,
      currency: w.currency,
      price: w.price,
      barcode: w.barcode,
      provider: w.provider,
      countryData: {
        carrierCompanyAddress: w.country_data.carrier_company_address,
        carrierCompanyName: w.country_data.carrier_company_name,
        countryCode: w.country_data.country_code,
        currencyType: w.country_data.currency_type,
        id: w.country_data.id,
      },
      weight: w.weight,
      quantity: w.quantity,
      regNumber: w.RegNumber,
      shop: w.shop_name || '',
      productPrice: { try: round2(parseFloat(w.product_price_try)), usd: round2(parseFloat(w.product_price_usd)) },
      deliveryPrice: round2(parseFloat(w.delivery_price)),
      totalPrice: round2(w.total_price),
      productType: { name: w.product_type_name },
      user: { id: w.user_id, fullName: w.user_name, phoneNumber: w.number, address: w.user_address, passportNumber: w.passport_number },
      currencyRate: round2(parseFloat(w.currency_rate)),
      printedAt: w.print_date,
    };
  }
}
